import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-deceased-details-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-deceased-details-cm.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { Validators } from "@angular/forms";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { CreateDeceasedDetailsCmConstant } from "./create-deceased-details-cm.constants";
import { DatePipe } from "@angular/common";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AppControllerService } from "../../../../app-controller.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { map, of } from "rxjs";
import { LookupConstants } from "../../../../shared/constants/lookup.constants";
import { DeceasedDtailsCustomValidators } from "../shared/custom-validators";
let CreateDeceasedDetailsCmComponent = class CreateDeceasedDetailsCmComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    appController;
    changeDetectorRefs;
    aflaModuleStrategyService;
    datePipe;
    selectedApplicationService;
    searchApplicationsService;
    deceasedFormGroupName = CreateDeceasedDetailsCmConstant.DECEASED_FORM_GROUP_NAME;
    nameControl = CreateDeceasedDetailsCmConstant.NAME_CONTROL;
    surnameControl = CreateDeceasedDetailsCmConstant.SURNAME_CONTROL;
    startDateControl = CreateDeceasedDetailsCmConstant.START_DATE_CONTROL;
    nameLabel = CreateDeceasedDetailsCmConstant.NAME_LABEL;
    surnameLabel = CreateDeceasedDetailsCmConstant.SURNAME_LABEL;
    startDateLabel = CreateDeceasedDetailsCmConstant.START_DATE_LABEL;
    sexLabel = CreateDeceasedDetailsCmConstant.SEX_LABEL;
    nationalityLabel = CreateDeceasedDetailsCmConstant.NATIONALITY_LABEL;
    maidenNameLabel = CreateDeceasedDetailsCmConstant.MAIDEN_NAME_LABEL;
    placeOfBirthLabel = CreateDeceasedDetailsCmConstant.PALCE_OF_BIRTH_LABEL;
    placeOfDeathLabel = CreateDeceasedDetailsCmConstant.PLACE_OF_DEATH_LABEL;
    provinceOfDeathLabel = CreateDeceasedDetailsCmConstant.PROVINCE_OF_DEATH_LABEL;
    identificationTypeLabel = CreateDeceasedDetailsCmConstant.IDENTITY_TYPE_LABEL;
    idNumberLabel = CreateDeceasedDetailsCmConstant.ID_PASSPORT_NUMBER_LABEL;
    dateOfDeathLabel = CreateDeceasedDetailsCmConstant.DATE_OF_DEATH_LABEL;
    dateOfBirthLabel = CreateDeceasedDetailsCmConstant.DATE_OF_BIRTH_LABEL;
    burialOrderNumberLabel = CreateDeceasedDetailsCmConstant.BURIAL_ORDER_LABEL;
    serialNumenerLabel = CreateDeceasedDetailsCmConstant.SERIAL_NUMBER_LABEL;
    verticalPositionLabel = CreateDeceasedDetailsCmConstant.VERTICAL_POSITION_LABEL;
    undertakerLabel = CreateDeceasedDetailsCmConstant.NAME_OF_THE_UNDERTAKER_LABEL;
    sexControl = CreateDeceasedDetailsCmConstant.SEX_CONTROL;
    nationalityControl = CreateDeceasedDetailsCmConstant.NATIONALITY_CONTROL;
    maidenNameControl = CreateDeceasedDetailsCmConstant.MAIDEN_NAME_CONTROL;
    placeOfBirthControl = CreateDeceasedDetailsCmConstant.PALCE_OF_BIRTH_CONTROL;
    placeOfDeathControl = CreateDeceasedDetailsCmConstant.PLACE_OF_DEATH_CONTROL;
    provinceOfDeathControl = CreateDeceasedDetailsCmConstant.PROVINCE_OF_DEATH_CONTROL;
    identificationTypeControl = CreateDeceasedDetailsCmConstant.IDENTITY_TYPE_CONTROL;
    idNumberControl = CreateDeceasedDetailsCmConstant.ID_PASSPORT_NUMBER_CONTROL;
    dateOfDeathControl = CreateDeceasedDetailsCmConstant.DATE_OF_DEATH_CONTROL;
    dateOfBirthControl = CreateDeceasedDetailsCmConstant.DATE_OF_BIRTH_CONTROL;
    burialOrderNumberControl = CreateDeceasedDetailsCmConstant.BURIAL_ORDER_CONTROL;
    serialNumberControl = CreateDeceasedDetailsCmConstant.SERIAL_NUMBER_CONTROL;
    verticalPositionControl = CreateDeceasedDetailsCmConstant.VERTICAL_POSITION_CONTROL;
    undertakerControl = CreateDeceasedDetailsCmConstant.NAME_OF_THE_UNDERTAKER_CONTROL;
    validationMessages = CreateDeceasedDetailsCmConstant.VALIDATION_MESSAGES;
    title = CreateDeceasedDetailsCmConstant.DECEASED_DETAILS_TITLE;
    sexPh = CreateDeceasedDetailsCmConstant.SEX_PH;
    nationalityPh = CreateDeceasedDetailsCmConstant.NATIONALITY_PH;
    provinceOfDeathPh = CreateDeceasedDetailsCmConstant.PROVINCE_OF_DEATH_PH;
    identityTypePh = CreateDeceasedDetailsCmConstant.IDENTITY_TYPE_PH;
    verticalPositionPh = CreateDeceasedDetailsCmConstant.VERTICAL_POSITION_PH;
    dropdownPlaceHolder = SharedConstants.PLACEHOLDER_TEXT;
    selectedBurialType;
    deceasedForm;
    nationalityLookup = LookupConstants.COUNTRIES;
    provinceLookup = LookupConstants.PROVINCE;
    dateofBirth;
    identificationTypeLookup = [];
    sexLookup = [];
    verticalPositionLookup = [];
    deceasedNameList = [];
    deceasedNamesControl = CreateDeceasedDetailsCmConstant.DECEASED_NAMES_CONTROL;
    lookupConst = {
        IdentificationType: "IDType",
        Sex: "Sex",
        VerticalPosition: "VerticalPosition"
    };
    pauperApplicationTypeName = "";
    requiredFieldState = {
        sex: true,
        nationality: true,
        identificationType: true,
        idNumber: true,
        dateOfBirth: true,
        placeOfBirth: true,
        burialOrderNumber: true,
        verticalPosition: true
    };
    getLookupsObservableSubscription;
    selectedApplicationCreateCmSubscription;
    getApplicationsSubscription;
    deceasedNameListSubscription;
    burialTypeValueChangesSubscription;
    deceasedNameListObservable;
    tableDataSource;
    constructor(applicationCreateService, appController, changeDetectorRefs, aflaModuleStrategyService, datePipe, selectedApplicationService, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.datePipe = datePipe;
        this.selectedApplicationService = selectedApplicationService;
        this.searchApplicationsService = searchApplicationsService;
        this.initForm();
    }
    ngOnInit() {
        this.getMetadata();
        this.loadLookups();
        this.checkSave();
        this.aflaModuleStrategyService.onCleanFormEvent.subscribe(x => {
            this.deceasedNameList = [];
            this.changeDetectorRefs.detectChanges();
        });
        this.subscribeToCheckFormValidity();
    }
    loadMetadata(stepMeta) {
        this.pauperApplicationTypeName = this.getPauperApplicationTypeName(stepMeta);
        this.refreshBurialTypeValidationState();
    }
    editnamesEvent(deceasedNameList) {
        this.deceasedNameList = deceasedNameList;
        this.deceasedForm.get(this.deceasedNamesControl).setValue(this.deceasedNameList);
    }
    addnamesEvent(deceasedNameList) {
        this.deceasedNameList = deceasedNameList;
        this.deceasedForm.get(this.dateOfBirthControl).setValue(this.datePipe.transform(this.deceasedNameList[0].startDate, "yyyy-MM-dd"));
    }
    populateForm(application) {
        if (application.deceased.length > 0) {
            application.deceased.forEach((deceased) => {
                this.deceasedForm.get(this.sexControl).setValue(deceased.sex);
                this.deceasedForm.get(this.nationalityControl).setValue(deceased.nationality);
                this.deceasedForm.get(this.maidenNameControl).setValue(deceased.maidenName);
                this.deceasedForm.get(this.placeOfBirthControl).setValue(deceased.placeOfBirth);
                this.deceasedForm.get(this.placeOfDeathControl).setValue(deceased.placeOfDeath);
                this.deceasedForm.get(this.provinceOfDeathControl).setValue(deceased.provinceOfDeath);
                this.deceasedForm.get(this.identificationTypeControl).setValue(deceased.idType);
                this.deceasedForm.get(this.idNumberControl).setValue(deceased.idNumber);
                this.deceasedForm.get(this.dateOfBirthControl).setValue(this.datePipe.transform(deceased.dateOfBirth, "yyyy-MM-dd"));
                this.deceasedForm.get(this.dateOfDeathControl).setValue(this.datePipe.transform(deceased.dateOfDeath, "yyyy-MM-dd"));
                this.deceasedForm.get(this.burialOrderNumberControl).setValue(deceased.burialOrderNumber);
                this.deceasedForm.get(this.serialNumberControl).setValue(deceased.serialNo);
                this.deceasedForm.get(this.verticalPositionControl).setValue(deceased.verticalPosition);
                this.deceasedForm.get(this.undertakerControl).setValue(deceased.undertaker);
                if (deceased.deceasedNames && deceased.deceasedNames.length > 0) {
                    this.addnamesEvent(deceased.deceasedNames);
                    this.deceasedForm.get(this.deceasedNamesControl).setValue(deceased.deceasedNames);
                    this.deceasedNameList = deceased.deceasedNames;
                    this.intDataSource();
                    this.changeDetectorRefs.detectChanges();
                }
            });
        }
        this.applyBurialTypeValidationState(this.selectedBurialType);
    }
    applyBurialTypeValidationState(burialTypeText) {
        const isPauperBurialType = this.isPauperBurialType(burialTypeText);
        if (isPauperBurialType) {
            this.clearPauperOptionalValidators();
        }
        else {
            this.applyRequiredValidators();
        }
        this.requiredFieldState = this.buildRequiredFieldState(!isPauperBurialType);
        this.deceasedForm.updateValueAndValidity({ emitEvent: false });
        this.changeDetectorRefs.markForCheck();
    }
    isPauperBurialType(burialTypeText) {
        const normalizedPauperApplicationTypeName = this.pauperApplicationTypeName.trim().toLowerCase();
        if (normalizedPauperApplicationTypeName === "") {
            return false;
        }
        const normalizedBurialType = burialTypeText.toLowerCase();
        return normalizedBurialType.includes(normalizedPauperApplicationTypeName);
    }
    getPauperApplicationTypeName(stepMeta) {
        if (stepMeta === null || stepMeta === undefined) {
            return "";
        }
        const metadataValue = stepMeta[CreateDeceasedDetailsCmConstant.PAUPER_APPLICATION_TYPE_NAME_METADATA_KEY];
        if (metadataValue === null || metadataValue === undefined) {
            return "";
        }
        return String(metadataValue);
    }
    clearPauperOptionalValidators() {
        const optionalControlNames = this.getPauperOptionalControlNames();
        optionalControlNames.forEach((controlName) => {
            this.clearControlValidators(controlName);
        });
        this.clearControlValidators(this.deceasedNamesControl);
    }
    applyRequiredValidators() {
        const requiredControlNames = this.getPauperOptionalControlNamesWithStandardRequiredValidator();
        requiredControlNames.forEach((controlName) => {
            this.applyRequiredValidator(controlName);
        });
        this.applyRequiredIdNumberValidators();
        this.applyRequiredDateOfBirthValidators();
        this.applyDeceasedNamesRequiredValidator();
    }
    getPauperOptionalControlNames() {
        return [
            ...CreateDeceasedDetailsCmConstant.PAUPER_OPTIONAL_FORM_CONTROL_NAMES,
            ...CreateDeceasedDetailsCmConstant.PAUPER_LEGACY_OPTIONAL_FORM_CONTROL_NAMES
        ];
    }
    getPauperOptionalControlNamesWithStandardRequiredValidator() {
        const optionalControlNames = this.getPauperOptionalControlNames();
        return optionalControlNames.filter((controlName) => {
            const hasSpecialRequiredValidator = controlName === this.idNumberControl ||
                controlName === this.dateOfBirthControl;
            return !hasSpecialRequiredValidator;
        });
    }
    clearControlValidators(controlName) {
        const control = this.deceasedForm.get(controlName);
        if (control === null) {
            return;
        }
        control.clearValidators();
        control.updateValueAndValidity({ emitEvent: false });
    }
    applyRequiredValidator(controlName) {
        const control = this.deceasedForm.get(controlName);
        if (control === null) {
            return;
        }
        control.setValidators([Validators.required]);
        control.updateValueAndValidity({ emitEvent: false });
    }
    applyRequiredIdNumberValidators() {
        const control = this.deceasedForm.get(this.idNumberControl);
        if (control === null) {
            return;
        }
        if (this.isSouthAfricanIdentificationTypeSelected()) {
            control.setValidators([
                Validators.required
            ]);
            control.updateValueAndValidity({ emitEvent: false });
            return;
        }
        control.setValidators([Validators.required]);
        control.updateValueAndValidity({ emitEvent: false });
    }
    applyRequiredDateOfBirthValidators() {
        const control = this.deceasedForm.get(this.dateOfBirthControl);
        if (control === null) {
            return;
        }
        control.setValidators([
            Validators.required,
            DeceasedDtailsCustomValidators.CompareDateToToday
        ]);
        control.updateValueAndValidity({ emitEvent: false });
    }
    isSouthAfricanIdentificationTypeSelected() {
        const control = this.deceasedForm.get(this.identificationTypeControl);
        if (control === null) {
            return false;
        }
        const identificationType = control.value;
        return identificationType === CreateDeceasedDetailsCmConstant.SA_ID_IDENTIFICATION_TYPE;
    }
    applyDeceasedNamesRequiredValidator() {
        const control = this.deceasedForm.get(this.deceasedNamesControl);
        if (control === null) {
            return;
        }
        control.setValidators([Validators.required]);
        control.updateValueAndValidity({ emitEvent: false });
    }
    buildRequiredFieldState(required) {
        return {
            sex: required,
            nationality: required,
            identificationType: required,
            idNumber: required,
            dateOfBirth: required,
            placeOfBirth: required,
            burialOrderNumber: required,
            verticalPosition: required
        };
    }
    initForm() {
        this.deceasedForm = this.aflaModuleStrategyService.form.get("deceasedForm");
        this.selectedBurialType = this.aflaModuleStrategyService.form.get("burialForm").get("type").value;
        this.deceasedForm.enable();
        this.enableDropdowns();
        this.listenForBurialTypeChanges();
    }
    listenForBurialTypeChanges() {
        const burialForm = this.aflaModuleStrategyService.form.get(CreateDeceasedDetailsCmConstant.BURIAL_FORM_GROUP_NAME);
        if (burialForm === null) {
            return;
        }
        const burialTypeControl = burialForm.get(CreateDeceasedDetailsCmConstant.BURIAL_TYPE_CONTROL);
        if (burialTypeControl === null) {
            return;
        }
        this.refreshBurialTypeValidationState();
        this.applyBurialTypeValidationState(this.selectedBurialType);
    }
    refreshBurialTypeValidationState() {
        if (this.deceasedForm === null || this.deceasedForm === undefined) {
            return;
        }
        const burialForm = this.aflaModuleStrategyService.form.get(CreateDeceasedDetailsCmConstant.BURIAL_FORM_GROUP_NAME);
        if (burialForm === null) {
            return;
        }
        const burialTypeControl = burialForm.get(CreateDeceasedDetailsCmConstant.BURIAL_TYPE_CONTROL);
        if (burialTypeControl === null) {
            return;
        }
        this.applyBurialTypeValidationState(this.selectedBurialType);
    }
    loadLookups() {
        this.getLookupsObservableSubscription = this.applicationCreateService.getLookupsObservable({ $filter: `moduleId eq ${this.appController.selectedModuleID} and name in ('${this.lookupConst.IdentificationType}','${this.lookupConst.Sex}','${this.lookupConst.VerticalPosition}') and deleted eq false` }).subscribe(lookupValues => {
            const lookup = lookupValues.value;
            lookup.forEach(lp => {
                if (lp.name === this.lookupConst.IdentificationType)
                    this.identificationTypeLookup.push(JSON.parse(lp.content));
                if (lp.name === this.lookupConst.Sex)
                    this.sexLookup.push(JSON.parse(lp.content));
                if (lp.name === this.lookupConst.VerticalPosition)
                    this.verticalPositionLookup.push(JSON.parse(lp.content));
            });
            this.identificationTypeLookup.sort((a, b) => a.value.localeCompare(b.value));
            this.sexLookup.sort((a, b) => a.value.localeCompare(b.value));
            this.verticalPositionLookup.sort((a, b) => a.value.localeCompare(b.value));
            this.changeDetectorRefs.detectChanges();
        });
    }
    checkSave() {
        this.selectedApplicationCreateCmSubscription = this.selectedApplicationService.$selectedApplication.subscribe(app => {
            if (app) {
                this.getApplicationDeceasedDetails(app);
            }
        });
    }
    enableDropdowns() {
        this.deceasedForm.get(this.sexControl).enable();
        this.deceasedForm.get(this.nationalityControl).enable();
        this.deceasedForm.get(this.identificationTypeControl).enable();
        this.deceasedForm.get(this.provinceOfDeathControl).enable();
        this.deceasedForm.get(this.verticalPositionControl).enable();
        this.deceasedForm.get(this.nationalityControl).setValue("South Africa");
    }
    idTypeChanged() {
        if (!this.requiredFieldState.idNumber) {
            this.clearControlValidators(this.idNumberControl);
            return;
        }
        this.applyRequiredIdNumberValidators();
    }
    updateDateOfBirth() {
        const dateValue = this.deceasedForm.get(this.dateOfBirthControl).value;
        this.dateofBirth = dateValue;
        this.changeDetectorRefs.detectChanges();
    }
    getApplicationDeceasedDetails(savedApplication) {
        const params = {
            $expand: "deceased($expand=deceasedNames)",
            $filter: `jobId eq ${savedApplication.jobId} and moduleId eq ${savedApplication.moduleId} and deleted eq false`
        };
        this.getApplicationsSubscription = this.aflaModuleStrategyService.getApplicationsQuery(params).subscribe({
            next: (application) => {
                const updatedApplication = application.value;
                if (updatedApplication.length > 0) {
                    this.populateForm(updatedApplication[0]);
                }
            }
        });
    }
    intDataSource() {
        this.tableDataSource = of(this.deceasedNameList)
            .pipe(map((resp) => {
            const sch = [];
            resp.forEach(el => {
                sch.push({
                    id: el.id,
                    name: el.name,
                    surname: el.surname,
                    startDate: this.datePipe.transform(el.startDate, "yyyy-MM-dd")
                });
            });
            return sch;
        }));
    }
    subscribeToCheckFormValidity() {
        this.applicationCreateService.$markStepFormGroupAsTouchedSubscription.subscribe({
            next: (formGroupName) => {
                if (formGroupName && this.deceasedForm && formGroupName === this.deceasedFormGroupName) {
                    this.deceasedForm.markAllAsTouched();
                    this.changeDetectorRefs.markForCheck();
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: AflaModuleStrategyService },
        { type: DatePipe },
        { type: SelectedApplicationService },
        { type: SearchApplicationsService }
    ];
};
CreateDeceasedDetailsCmComponent = __decorate([
    Component({
        selector: "app-create-deceased-details-cm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateDeceasedDetailsCmComponent);
export { CreateDeceasedDetailsCmComponent };
